export default "__VITE_ASSET__CNP9ihmE__"